// Keep this in sync with APP_VERSION in backend/server.py.
export const APP_VERSION = "2.0.1";
